module.exports = __webpack_public_path__ + "img/it_extensiondegarantia.00b5206b.svg";